import React, { memo } from 'react';
import styled from 'styled-components';
import { ForecastCardIcon } from '../../common/forecastCardIcon';
import { IForecastCard } from '../../common/types';
import { CommonContainerStyle } from '../styles';
import { TemperatureInfo } from './temperatureInfo';

type ConditionsWeatherInfoProps = Pick<IForecastCard, 'temperature'| 'iconCode' | 'feelsLike'>;

export const ConditionsWeatherInfo = memo(({ temperature, iconCode, feelsLike }: ConditionsWeatherInfoProps) => {
    return (
        <Container>
            <TemperatureInfo temperature={temperature} feelsLike={feelsLike} />
            <ForecastCardIcon iconCode={iconCode} />
        </Container>
    );
});

const Container = styled.div`
    ${CommonContainerStyle}
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    height: 50%;
`;